import React, { FunctionComponent } from 'react';
import { useQuery } from '@apollo/client';

import { MAGENTO_URL } from '../../../config/client.config';
import ExternalRedirect from '../../routes/ExternalRedirect';
import { EMPTY } from '../../constants/cartTypes';
import { CartTypeQuery } from '../../graphql/cart';
import { CartTypeQuery as CartTypeQueryResult } from '../../graphql/__generated__/CartTypeQuery';

const CartTypeCheck: FunctionComponent = ({ children }) => {
  const { loading, error, data } = useQuery<CartTypeQueryResult>(
    CartTypeQuery,
    { fetchPolicy: 'network-only', ssr: false }
  );

  if (loading) return <>{children}</>;

  if (error) return null;

  return data?.user?.cart.type === EMPTY ? (
    <ExternalRedirect to={`${MAGENTO_URL}/checkout/cart`} />
  ) : (
    <>{children}</>
  );
};

export default CartTypeCheck;
